<div class="cal-container">
  <div class="cal-nav">
    <button type="button" class="cal-nav-btn" (click)="semanaAnterior()" pTooltip="Semana anterior"
      tooltipPosition="top" aria-label="Semana anterior">
      <i class="ri-arrow-left-s-line"></i>
    </button>

    <div class="cal-nav-label">
      <i class="ri-calendar-schedule-line"></i>
      <strong>Semana de {{ getSemanaLabel() }}</strong>
    </div>

    <button type="button" class="cal-nav-btn" (click)="semanaSeguinte()" pTooltip="Semana seguinte"
      tooltipPosition="top" aria-label="Semana seguinte">
      <i class="ri-arrow-right-s-line"></i>
    </button>

    <button type="button" class="cal-hoje-btn" (click)="irParaHoje()" [disabled]="isCurrentWeek"
      [attr.aria-current]="isCurrentWeek ? 'date' : null">
      Hoje
    </button>

    <div class="cal-legend" aria-label="Legenda de assiduidade">
      <span><b class="legend-dot presente"></b> Presente</span>
      <span><b class="legend-dot atraso"></b> Entrada tardia</span>
      <span><b class="legend-dot falta"></b> Falta</span>
      <span><b class="legend-dot planeado"></b> Planeado</span>
    </div>
  </div>

  <div class="cal-week-summary" *ngIf="!loading && calendarRows.length" aria-label="Resumo da semana visível">
    <div class="cal-week-stats">
      <span><i class="ri-calendar-check-line"></i><strong>{{ totalTurnosPlaneados }}</strong> planeados</span>
      <span class="success"><i class="ri-user-follow-line"></i><strong>{{ totalPresencas }}</strong> presenças</span>
      <span class="warning"><i class="ri-timer-line"></i><strong>{{ totalAtrasos }}</strong> atrasos</span>
      <span class="danger"><i class="ri-user-unfollow-line"></i><strong>{{ totalFaltas }}</strong> faltas</span>
    </div>
    <p class="cal-guide" *ngIf="!isReadonly">
      <i class="ri-cursor-line"></i>
      Clique numa célula vazia para criar; clique numa escala para consultar ou editar.
    </p>
  </div>

  <div *ngIf="loading" class="cal-skeleton">
    <p-skeleton height="50px" borderRadius="10px"></p-skeleton>
    <p-skeleton *ngFor="let row of skeletonRows" height="78px" borderRadius="10px"></p-skeleton>
  </div>

  <div *ngIf="!loading && calendarRows.length && contexto === 'posto'" class="cal-table-wrap">
    <table class="cal-table">
      <caption class="sr-only">Planeamento semanal dos efetivos do posto</caption>
      <thead>
        <tr>
          <th class="cal-th-ef" scope="col">Efetivo</th>
          <th *ngFor="let dia of diasSemana" class="cal-th-day" scope="col" [class.hoje]="dia.hoje">
            <span>{{ dia.dia }}</span>
            <strong>{{ dia.numero }}</strong>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of calendarRows; trackBy: trackEfetivo">
          <th class="cal-td-ef" scope="row">
            <div class="cal-ef-cell">
              <span class="cal-ef-avatar">
                <img *ngIf="row.efetivo.urlFoto" [src]="row.efetivo.urlFoto" [alt]="row.efetivo.nome" />
                <span *ngIf="!row.efetivo.urlFoto">{{ row.iniciais }}</span>
              </span>
              <span class="cal-ef-info">
                <strong [pTooltip]="row.efetivo.nome" tooltipPosition="right">
                  {{ row.efetivo.nome }}
                </strong>
                <small>{{ row.efetivo.codigo || row.efetivo.cargo || 'Alocado' }}</small>
              </span>
            </div>
          </th>

          <td *ngFor="let cell of row.cells; trackBy: trackDia" class="cal-td-day" [class.hoje]="cell.hoje">
            <div *ngIf="cell.escala && !cell.exibirFolgaNoLugarDaEscala" class="turno-card" role="button" tabindex="0"
              [class.readonly]="isReadonly" [ngClass]="[getEstadoOperacionalClass(cell.estadoOperacional)]"
              [class.has-conflict]="cell.conflitos > 1" [pTooltip]="getCellTooltip(cell)"
              [attr.aria-label]="getCellAriaLabel(row, cell)" tooltipPosition="top" (click)="abrirSlot(row, cell)"
              (keydown.enter)="abrirSlot(row, cell)" (keydown.space)="$event.preventDefault(); abrirSlot(row, cell)">
              <span class="turno-card-head">
                <span class="turno-icon" [ngClass]="getTipoClass(cell.tipo)">
                  <i [class]="getTurnoIcon(cell.tipo)"></i>
                </span>
                <span class="turno-schedule">{{ cell.horario }}</span>

                <!-- Ações na célula da escala -->
                <span *ngIf="!isReadonly" class="cell-action-stack">

                  <!-- BOTÃO EDITAR -->
                  <button
                    *ngIf="cell.estadoOperacional !== 'falta' && cell.estadoOperacional !== 'presente' && cell.estadoOperacional !== 'atraso'; else edicaoBloqueada"
                    type="button" class="cell-action-btn edit" aria-label="Editar escala deste dia"
                    pTooltip="Editar escala" tooltipPosition="left" (click)="abrirEdicao($event, row, cell)">
                    <i class="ri-edit-line"></i>
                  </button>
                  <ng-template #edicaoBloqueada>
                    <button type="button" class="cell-action-btn edit locked" disabled
                      [attr.aria-label]="cell.estadoOperacional === 'falta' ? 'Edição bloqueada por falta registada' : 'Edição bloqueada: turno já iniciado'"
                      [pTooltip]="cell.estadoOperacional === 'falta' ? 'Remova a falta antes de editar a escala' : 'Não é possível editar este turno porque já foi iniciado.'"
                      tooltipPosition="left">
                      <i class="ri-lock-line"></i>
                    </button>
                  </ng-template>

                  <!-- BOTÃO MARCAR FALTA -->
                  <button
                    *ngIf="cell.estadoOperacional !== 'falta' && cell.estadoOperacional !== 'presente' && cell.estadoOperacional !== 'atraso'"
                    type="button" class="cell-action-btn absence" aria-label="Marcar falta neste dia"
                    pTooltip="Marcar falta" tooltipPosition="left" (click)="abrirFalta($event, row, cell)">
                    <i class="ri-user-unfollow-line"></i>
                  </button>

                  <button *ngIf="cell.estadoOperacional === 'falta'" type="button"
                    class="cell-action-btn absence confirmed" pTooltip="Ver detalhes da falta" tooltipPosition="left"
                    (click)="abrirFalta($event, row, cell)">
                    <i class="ri-user-unfollow-fill"></i>
                  </button>

                  <button *ngIf="cell.estadoOperacional === 'presente' || cell.estadoOperacional === 'atraso'"
                    type="button" class="cell-action-btn absence locked" disabled
                    aria-label="Falta bloqueada: efetivo em serviço"
                    pTooltip="Não é possível marcar falta porque o efetivo já deu entrada neste turno." tooltipPosition="left">
                    <i class="ri-user-unfollow-line"></i>
                  </button>

                  <!-- BOTÃO REMOVER / ELIMINAR -->
                  <button type="button" class="cell-action-btn remove" [class.locked]="isRemocaoBloqueada(cell)"
                    [disabled]="isRemocaoBloqueada(cell)" aria-label="Remover efetivo deste dia"
                    [pTooltip]="getRemocaoTooltip(cell)" tooltipPosition="left"
                    (click)="abrirRemocao($event, row, cell)">
                    <i class="ri-delete-bin-6-line"></i>
                  </button>

                </span>
              </span>

              <span class="turno-main">
                <strong *ngIf="cell.horaEntrada"><i class="ri-login-box-line"></i> {{ cell.horaEntrada }}</strong>
                <strong *ngIf="!cell.horaEntrada && cell.estadoOperacional === 'falta'" class="falta-label">
                  <i class="ri-user-unfollow-line"></i> Falta
                </strong>
                <strong *ngIf="!cell.horaEntrada && cell.estadoOperacional !== 'falta'">{{ cell.estadoLabel }}</strong>
                <small *ngIf="cell.horaEntrada">entrada</small>
                <small *ngIf="cell.estadoOperacional === 'falta'">Ausência registada</small>
              </span>

              <button *ngIf="cell.conflitos > 1" type="button" class="conflict-icon fas fa-exclamation-triangle"
                [pTooltip]="cell.conflitos + ' escalas sobrepostas neste dia'" tooltipPosition="top"
                (click)="abrirConflitos($event, row, cell)"
                [attr.aria-label]="'Ver ' + cell.conflitos + ' escalas sobrepostas'"></button>
            </div>

            <div *ngIf="cell.folga" class="turno-card folga-card"
              [class.readonly]="isReadonly" [ngClass]="[getEstadoOperacionalClass(folgaEstadoOperacional)]"
              [pTooltip]="getCellTooltip(cell)" [attr.aria-label]="getCellAriaLabel(row, cell)" tooltipPosition="top">
              <span class="turno-card-head">
                <span class="turno-icon folga-icon"><i class="ri-moon-clear-line"></i></span>
              </span>
              <span class="turno-main">
                <strong>Folga</strong>
                <small *ngIf="cell.folga?.tipo === 'inicio'">Início: {{ getFolgaInicio(cell) }}</small>
                <small *ngIf="cell.folga?.tipo === 'continuidade'">Termina</small>
                <small *ngIf="cell.folga?.tipo === 'continuidade'">{{ getFolgaTerminoDia(cell) }}</small>
                <small *ngIf="cell.folga?.tipo === 'continuidade'">às {{ getFolgaTerminoHora(cell) }}</small>
              </span>
            </div>

            <button *ngIf="!cell.escala && !cell.folga" type="button" class="turno-empty" [class.readonly]="isReadonly" [pTooltip]="getCellTooltip(cell)"
              [attr.aria-label]="getCellAriaLabel(row, cell)" tooltipPosition="top" (click)="abrirSlot(row, cell)">
              <i *ngIf="!isReadonly" class="ri-add-line"></i>
              <span *ngIf="isReadonly">-</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!loading && calendarRows.length && contexto === 'efetivo'" class="person-calendar-wrap">
    <table class="person-calendar">
      <thead>
        <tr>
          <th></th>
          <th *ngFor="let dia of diasSemana" [class.hoje]="dia.hoje" [class.selected-day]="isDaySelected(dia)">
            <span>{{ dia.dia }}</span><strong>{{ dia.numero }}</strong>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="calendarRows[0] as row">
        <tr>
          <th><i class="ri-calendar-line"></i> Horário</th>
          <td *ngFor="let cell of row.cells" [class.hoje]="cell.hoje"
            [class.selected-day]="isCellSelected(cell, 'horario')">
            <button *ngIf="cell.escala" type="button" class="person-event previsto"
              [class.selected]="isCellSelected(cell, 'horario')" (click)="abrirSlot(row, cell, 'horario')">
              <i [class]="getHorarioTurnoIcon(cell)" aria-hidden="true"></i>
              <span>{{ cell.horario }}</span>
            </button>
          </td>
        </tr>
        <tr>
          <th><i class="ri-login-circle-line"></i> Efectividade Processada</th>
          <td *ngFor="let cell of row.cells" [class.hoje]="cell.hoje"
            [class.selected-day]="isCellSelected(cell, 'efectividade')">
            <button *ngIf="cell.escala" type="button" class="person-event real"
              [class.pending]="!cell.horaEntrada && cell.estadoOperacional !== 'falta'"
              [class.blocked]="cell.estadoOperacional === 'falta'"
              [class.selected]="isCellSelected(cell, 'efectividade')"
              [ngClass]="getEstadoOperacionalClass(cell.estadoOperacional)" [pTooltip]="getEfectividadeDescricao(cell)"
              tooltipPosition="top" (click)="abrirSlot(row, cell, 'efectividade')">
              <i [class]="cell.horaEntrada ? 'ri-login-circle-line' : 'ri-time-line'"></i>
              <span class="person-event-copy">
                <strong>{{ getEfectividadeLabel(cell) }}</strong>
                <small>{{ getEfectividadeDescricao(cell) }}</small>
              </span>
            </button>
          </td>
        </tr>
        <tr>
          <th><i class="ri-timer-flash-line"></i> Assiduidade Processada</th>
          <td *ngFor="let cell of row.cells" [class.hoje]="cell.hoje"
            [class.selected-day]="isCellSelected(cell, 'assiduidade')">
            <button *ngIf="cell.escala" type="button" class="person-event assiduidade"
              [class.pending]="!cell.horaEntrada" [class.selected]="isCellSelected(cell, 'assiduidade')"
              [pTooltip]="getAssiduidadeDescricao(cell)" tooltipPosition="top"
              (click)="abrirSlot(row, cell, 'assiduidade')">
              <i [class]="cell.horaEntrada ? 'ri-timer-flash-line' : 'ri-loader-2-line'"></i>
              <span class="person-event-copy">
                <strong>{{ getAssiduidadeLabel(cell) }}</strong>
                <small>{{ getAssiduidadeDescricao(cell) }}</small>
              </span>
            </button>
          </td>
        </tr>
        <tr>
          <th><i class="ri-alert-line"></i> Ausência</th>
          <td *ngFor="let cell of row.cells" [class.hoje]="cell.hoje"
            [class.selected-day]="isCellSelected(cell, 'ausencia')">
            <button *ngIf="cell.escala" type="button" class="person-event ausencia-state"
              [class.falta]="cell.estadoOperacional === 'falta'" [class.clear]="cell.estadoOperacional !== 'falta'"
              [class.selected]="isCellSelected(cell, 'ausencia')" [pTooltip]="getAusenciaDescricao(cell)"
              tooltipPosition="top" (click)="abrirSlot(row, cell, 'ausencia')">
              <i [class]="cell.estadoOperacional === 'falta' ? 'ri-user-unfollow-line' : 'ri-shield-check-line'"></i>
              <span class="person-event-copy">
                <strong>{{ getAusenciaLabel(cell) }}</strong>
                <small>{{ getAusenciaDescricao(cell) }}</small>
              </span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!loading && !calendarRows.length" class="cal-empty">
    <div class="cal-empty-icon"><i class="ri-calendar-close-line"></i></div>
    <strong>Sem efetivos para apresentar</strong>
    <span>Não foi possível montar a grelha semanal deste posto.</span>
  </div>
</div>